var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(-180 24 23.5)",
    fill: "#1C1C1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(-180 24 23.5)",
    stroke: "#636366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8984 12.1016C16.1094 12.3359 16.1094 12.6875 15.8984 12.8984L11.3984 17.3984C11.1641 17.6328 10.8125 17.6328 10.6016 17.3984C10.3672 17.1875 10.3672 16.8359 10.6016 16.625L14.7031 12.5234L10.6016 8.39844C10.3672 8.1875 10.3672 7.83594 10.6016 7.625C10.8125 7.39062 11.1641 7.39062 11.375 7.625L15.8984 12.1016Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand_icon.16bc07858e6f4233101d4f233bb847ab.svg";
export { ForwardRef as ReactComponent };